import { render, staticRenderFns } from "./AutomaticDiscounts.vue?vue&type=template&id=5c57a5c9"
import script from "./AutomaticDiscounts.vue?vue&type=script&lang=js"
export * from "./AutomaticDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports